import { componentFactoryOf } from 'vue-tsx-support';

import { JtnUiTypography, JtnUiBtnIcon } from '@jtnews/jtn-ui';
import { injectStylesMixin, tsStoreMixin } from '@jtnews/shared';

import styles from './blocked-user-form.styles.scss?module';

const RULES_LINK = '/comments/rules/';

type ModalEvents = {
  onClosed(): void;
};

export default componentFactoryOf<ModalEvents>()
  .mixin(injectStylesMixin(styles))
  .mixin(tsStoreMixin)
  .create({
    name: 'BlockedUserForm',
    computed: {
      isMobilePhone(): boolean {
        return this.store.deviceInfo.isMobile && !this.store.deviceInfo.isTablet;
      }
    },
    methods: {
      closeModal() {
        this.$emit('closed');
      }
    },
    render() {
      const CLOSE_ICON_SIZE = 14;

      return (
        <div class={[styles.blockedUserModal, this.isMobilePhone ? styles._mobile : '']}>
          <JtnUiBtnIcon
            class={[styles.closeBtn, this.isMobilePhone ? styles._mobile : '']}
            btn-type="button-other-transparent"
            size={CLOSE_ICON_SIZE}
            onClick={() => {
              this.closeModal();
            }}
          >
            <svg width={CLOSE_ICON_SIZE} height={CLOSE_ICON_SIZE}>
              <use xlinkHref="/dist/legacy/svg-sprites/jtn-critical.42b7545660e4f467e75d4b37a02533e6.svg#jtn-critical-close"></use>
            </svg>
          </JtnUiBtnIcon>
          <JtnUiTypography
            class={[
              styles.blockedUserModalHeader,
              this.isMobilePhone ? styles._mobile : ''
            ]}
            tag="h3"
            type="font-modal-title-gray"
          >
            Ваш профиль заблокирован
          </JtnUiTypography>
          <JtnUiTypography class={styles.blockedUserModalText} tag="p">
            <span>
              Для вашего профиля заблокирована возможность добавлять комментарии
              и&nbsp;оценивать комментарии других пользователей.
            </span>
            <br />
            <br />
            <span>Причина: нарушение </span>
            <JtnUiTypography
              class={styles.message}
              tag="a"
              type="font-vijet-type-1"
              link-type="link-blue"
              target="_blank"
              href={RULES_LINK}
            >
              правил
            </JtnUiTypography>
            .
          </JtnUiTypography>
        </div>
      );
    }
  });
